import { render, staticRenderFns } from "./on-page-breadcrumbs.vue?vue&type=template&id=3879bbcb&"
import script from "./on-page-breadcrumbs.vue?vue&type=script&lang=js&"
export * from "./on-page-breadcrumbs.vue?vue&type=script&lang=js&"
import style0 from "./on-page-breadcrumbs.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports